module.exports = __webpack_public_path__ + "static/img/stuck-im-neubau_2.3573922.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stuck-im-neubau_2.jpg
// module id = EzpB
// module chunks = 1